import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Button, Grid, Loader, Message } from "semantic-ui-react";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	password: Yup.string()
		.min(4, "Longueur min : 4 caractères")
		.matches(/[A-Z]/, { message: "Au moins un caractère majuscule" })
		.matches(/[a-z]/, { message: "Au moins un caractère minuscule" })
		.matches(/[0-9]/, { message: "Au moins un numéro" })
		.required("Champs requis"),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref("password"), null], "Les mots de passe sont différents")
		.min(4, "Longueur min : 4 caractères")
		.required("Champs requis"),
});

const ResetPassword = ({ logout, resetPassword }) => {
	const [showWarning, setShowWarning] = useState("");

	return (
		<Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
			<Grid.Column style={{ maxWidth: 450, padding: 40 }}>
				<div
					style={{
						boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
						backgroundColor: "#fff",
						padding: 20,
						borderRadius: "0 0 4px 4px",
					}}
				>
					<span style={{ fontWeight: "bold", marginBottom: 5 }}>Veuillez saisir un nouveau mot de passe</span>
					<Formik
						initialValues={{
							password: "",
							confirmPassword: "",
						}}
						validationSchema={schemaValidation}
						onSubmit={async (values, { setSubmitting }) => {
							const res = await resetPassword(values.password);
							if (res?.error?.response?.status === 400) setShowWarning(res?.error?.response?.data?.message);
							else setShowWarning(null);
							setSubmitting(false);
						}}
					>
						{({ isSubmitting }) => (
							<Form>
								{showWarning && <Message warning header="Attention" content={showWarning} />}
								<Field customlabel="Mot de passe" type="password" name="password" component={CustomInputTextComponent} />
								<Field customlabel="Confirmer le mot de passe" type="password" name="confirmPassword" component={CustomInputTextComponent} />
								<div style={{ marginTop: 5 }}>
									{!isSubmitting ? (
										<>
											<Button
												color="red"
												onClick={async (e) => {
													if (e !== undefined) e.preventDefault();
													await logout();
												}}
											>
												Annuler
											</Button>
											<Button type="submit" color="green">
												Valider
											</Button>
										</>
									) : (
										<Loader active inline />
									)}
								</div>
							</Form>
						)}
					</Formik>
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default ResetPassword;
